/* eslint-disable camelcase */
/* eslint-disable react/static-property-placement */
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { defineMessages, FormattedMessage, intlShape } from 'react-intl';
import cx from 'classnames';
import moment from 'moment';

import Link from '../../components/Link';

import s from './CityCard.css'; // eslint-disable-line css-modules/no-unused-class

const messages = defineMessages({
  fullHotelName: {
    id: 'ourHotelCard.fullHotelName',
    defaultMessage: '##Red Planet {hotelName}##',
    description:
      'Full city name in Our Hotel page. Do not translate or remove {hotelName}',
  },
});

class CityCard extends React.Component {
  static propTypes = {
    countryId: PropTypes.number.isRequired,
    city: PropTypes.shape({
      name: PropTypes.string,
      image_path: PropTypes.string,
      children: PropTypes.arrayOf(
        PropTypes.shape({
          hotels: PropTypes.arrayOf(
            PropTypes.shape({
              id: PropTypes.number,
              name: PropTypes.string,
              slug_name: PropTypes.string,
            }),
          ),
        }),
      ),
    }).isRequired,
  };

  static contextTypes = {
    intl: intlShape,
  };

  render() {
    const { countryId, city } = this.props;
    const { locale } = this.context.intl;
    const hotels = [];
    city.children.forEach(area => {
      if (area.hotels !== null) {
        hotels.push(...area.hotels);
      }
    });
    const checkIn = moment().format('YYYY-MM-DD');
    const checkOut = moment()
      .add(1, 'd')
      .format('YYYY-MM-DD');
    return (
      <div
        className={cx(s.root, s[locale])}
        style={{ backgroundImage: `url('${city.image_path}')` }}
      >
        <div className={s.overlay} />
        <Link
          to={`/search/?country=${countryId}&city=${city.id}&check_in=${checkIn}&check_out=${checkOut}&rooms=1&adults=2&children=0`}
        >
          <h2>{city.name}</h2>
        </Link>
        <ul>
          {hotels.map(hotel => (
            <li key={hotel.id}>
              <Link to={`/hotel/${hotel.slug_name}`}>
                <FormattedMessage
                  {...messages.fullHotelName}
                  values={{
                    hotelName: hotel.name,
                  }}
                />
                &nbsp;
                {hotel.opening_soon && <span>(OPENING SOON)</span>}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

export default withStyles(s)(CityCard);
